export default __webpack_public_path__ + "static/media/expired-verification-link.a334e52c.svg";